export default __webpack_public_path__ + "static/ben-1-4620d55fad9000ea441b4754689415d0.png";